module.exports = __webpack_public_path__ + "static/media/whats-hireed-right.f64e68b4.jpg";